var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLines = function SvgArrowLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h18M3 22h18M9.473 8.509l1.8-2.135c.37-.441.995-.445 1.4 0l1.78 2.135m-2.48-1.425v4.324l-.001 5.591m2.5-1.424-1.8 2.134c-.37.442-.994.446-1.4 0l-1.78-2.134"
  })));
};
export default SvgArrowLines;